module.exports = __webpack_public_path__ + "img/rotate.a237c6d3.png";